export const keyMapsAction = {
  GET_REORDER_DATA: "ReOrder/getReOrderData",
  GET_PREVIOUS_ORDER_DATA: "ReOrder/getPreviousSingleOrder",
  GET_ORDER_DETAILS_DATA: "ReOrder/getOrderDetailsData",
  GET_NEXT_ORDER_BATCH_DATA: "ReOrder/getNextOrderBatchData",
  REORDER_ITEMS: "ReOrder/reorderItems",
  GET_FAVOURITE_DATA: "Favourite/getFavouriteData",
  GET_FAVOURITE_IDS_API: "ProductItems/getFavouriteIdsApi",
  ADDTO_FAVOURITE_API: "ProductItems/addToFavouriteApi",
  REMOVE_FROM_FAVOURITE_API: "ProductItems/removeFromFavouriteApi",
  GET_INLINE_NOTIFICATION_DATA: "Notification/getNotificationData",
  WELCOME_OFFER_API: "Offers/welcomeOfferApi",
  APPLY_OFFER_API: "Offers/applyOfferApi",
  REMOVE_OFFER_API: "Offers/removeOfferApi",
  OFFER_TNC_API: "Offers/offerTncApi",
  ANONYMOUS_USER_API: "Auth/anonymousUserApi",
  FORGOT_PASSWORD_API: "Auth/forgotPasswordApi",
  LOGOUT_USER_API: "Auth/logoutUserApi",
  VALIDATE_OTP_API: "Auth/validateOtpCodeApi",
  LOAD_LOGIN_STATUS: "Auth/loadLoginStatus",
  //Location Apis
  GEO_CODE_API: "Location/geoCodeApi",
  GEO_CODE_API_COMBO: "Location/geoCodeApiCombo",
  CACHED_STORE_API: "Location/cachedStoreApi",
  DETECT_GEO_LOCATION_POPUP: "Location/detectGeoLocationPopup",
  GOOGLE_GEO_LOCATION_API: "Location/googleGeoLocationApi",
  STORE_DETAILS_API: "Location/storeDetailsApi",
  DETECT_CURRENT_LOCATION: "Location/detectCurrentLocation",
  AUTOCOMPLETE_LOCATION_API: "Location/autoCompleteApi",
  SAVE_CURRENT_GPS_LOCATION: "Location/saveCurrentGPSLocation",
  LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE:
    "Location/loadRecentLocationFromLocalStorage",
  UPDATE_CACHED_STORE_DATA: "Location/updateCachedStoreData",
  LOCATOR_STORE_TAKEAWAY_DINEIN_AVAILABILITY_API:
    "Location/locatorStoreTakeawayDineInAvailabilityApi",

  //User Apis
  SAVED_ADDRESSES_API: "User/getSavedAddressesApi",
  UPDATE_ADDRESS_API: "User/updateAddressApi",
  DELETE_ADDRESS_API: "User/deleteAddressApi",
  ADD_ADDRESS_API: "User/addAddressApi",
  GET_USER_INFO_API: "User/getUserInfoApi",
  UPDATE_USER_INFO_API: "User/updateUserInfoApi",
  STATIC_WIDGET_API: "User/staticWidgetApi",
  // PAYMENT_OFFER_TNC_API: "PaymentOffers/paymentOfferTncApi",
  // PAYMENT_OFFER_API: "PaymentOffers/paymentOfferApi",
  BANNER_OFFER_API: "BannerOffers/bannerOfferApi",
  WHAT_MAKES_US_DIFF: "BannerOffers/whatMakesUsDiffApi",
  LOCATOR_STORE_TAKEAWAY_API: "Location/locatorStoreTakeawayApi",
  SG_INFO_API: "Cart/sgInfoApi",
  ADVANCE_ORDER_API: "Cart/adavanceOrderApi",
  GET_CART_ITEMS_API: "Cart/getCartItemsApi",
  UPDATE_CART_ITEMS_API: "Cart/updateCartItemsApi",
  CREATE_CART_ITEMS_API: "Cart/createCartItemsApi",
  GET_PRODUCT_INFO_BY_API: "Cart/getProductInfoByIdApi",
  HAMBURGER_ITEMS_API: "Profile/hamburgerItemsApi",
  // Order Tracking APIs
  GET_TRACK_ORDER_API: "OrderTracking/getTrackOrder",
  CANCEL_ORDER_API: "OrderTracking/cancelOrderApi",
  ACTIVE_ORDERS_API: "OrderTracking/activeOrders",
  POST_ORDER_TRACKER_API: "OrderTracking/postOrderTracker",
  GET_GLOBAL_UPSELL_ITEMS_API: "Cart/getGlobalUpsellItemsApi",
  POST_SUBMIT_TRACK_ORDER: "OrderTracking/postSubmitTrackOrder",
  SEND_FINGER_PRINT: "FingerPrint/sendFingerPrint",
  //Cart Payment APIs
  LAST_SUCCESSFULL_PAYMENT_API: "CartPayment/getLastSuccessFullPaymentApi",
  GET_MULTIPLE_RECOMMENDATION_DATA:
    "MultipleRecommendation/getMultipleRecommendationData",
  CHECK_DUPLICATE_ORDER_API: "Cart/checkDuplicateOrderApi",
  GET_TOAST_MESSAGES_FROM_LOCAL_STORAGE:
    "NotifyToast/getToastMessagesFromLocalStorage",

  //Csat APIs
  CSAT_FEEDBACK_API: "CsatFeedback/csatFeedbackApi",
  SUBMIT_CSAT_FEEDBACK_API: "CsatFeedback/submitCsatFeedbackApi",
  UPDATE_CSAT_FEEDBACK_API: "CsatFeedback/updateCsatFeedbackApi",
  SUBMIT_CSAT_ADDITIONAL_FEEDBACK_API:
    "CsatFeedback/submitCsatAdditionalFeedbackApi",
  GET_NPS_CSAT_HOME_WIDGET: "CsatFeedback/getHomeWidget",
  NPS_CSAT_DISMISS_HOME_WIDGET: "CsatFeedback/dismissHomeWidget",

  //Wallet APIs
  GET_WALLET_BALANCE_DATA: "WalletInfo/getWalletBalanceData",
  GET_WALLET_TRANSACTION_DATA: "WalletInfo/getWalletTransactionData",
  //SavedPaymentModes APIs
  GET_SAVED_CARD_PAYMENT_MODES: "SavedPaymentModes/getSavedCardPaymentModes",
  DELETE_SAVED_CARD_API: "SavedPaymentModes/deleteSavedCardsApi",
};

export const keyMapsMutation = {
  UPDATE_REORDER_DATA: "ReOrder/updateReOrderData",
  UPDATE_IMG_BASE_URL: "ProductItems/updateImgBaseUrl",
  UPDATE_PRODUCTS_IN_STORE: "ProductItems/updateProductsInStore",
  UPDATE_SHOW_CUSTOMISABLE_FOR: "ProductItems/updateShowCustomisableFor",
  UPDATE_SHOW_PRODUCT_CARD_IN_MODAL_FOR:
    "ProductItems/updateShowProductCardInModal",
  UPDATE_SHOW_REPEAT_CUST_MODAL: "ProductItems/updateShowRepeatCustModal",
  UPDATE_SHOULD_SHOW_ALL_PRODUCT_CATEGORIES:
    "ProductItems/updateShouldShowAllProductCategories",
  UPDATE_SHOW_CUSTOMIZATION_MODAL: "ProductItems/updateShowCustomizationModal",
  UPDATE_SHOW_EDIT_MINI_CART_MODAL: "ProductItems/updateShowEditMiniCartModal",
  UPDATE_ITEMS_QUANTITY_MINI_CART_CUST:
    "ProductItems/updateItemsQuantityMiniCartCust",
  UPDATE_ITEMS_LIST_MINI_CART_CUST: "ProductItems/updateItemsListMiniCartCust",
  UPDATE_SHOW_SEARCH_MODAL: "ProductItems/updateShowSearchModal",
  UPDATE_PRODUCT_CATEGORY: "ProductItems/updateProductCategory",
  MARK_FAVOURITE_IDS: "ProductItems/markFavouriteIds",
  UNMARK_FAVOURITE_IDS: "ProductItems/unmarkFavouriteIds",
  UPDATE_SELECTED_GROUP_INDEXES: "ProductItems/updateSelectedGroupsIndexes",
  UPDATE_SELECTED_VARIANT_INDEX: "ProductItems/updateSelectedVariantIndex",
  UPDATE_APPLIED_FILTERS_AND_SORTS: "ProductItems/updateAppliedFiltersAndSorts",
  UPDATE_SHOW_SUB_CATEGORY_MODAL: "ProductItems/updateShowSubCategoryModal",
  UPDATE_SHOW_SUB_CATEGORY_DATA: "ProductItems/updateShowSubCategoryData",
  UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED:
    "ProductItems/updateIsRemoveItemPopup",
  UPDATE_SELECTED_ITEM_IN_CART: "ProductItems/updateSelectedItemInCart",
  UPDATE_SELECTED_COMBO_INVALID_ITEMS_LIST:
    "ProductItems/updateSelectedComboInvalidItemsList",
  UPDATE_SELECTED_ITEM_IN_CART_QUANTITY:
    "ProductItems/updateSelectedItemInCartQuantity",
  SET_PRODUCT_OBSERVER: "ProductItems/setProductObserver",
  TRIGGER_FILTER_REF: "ProductItems/triggerClearFilterRef",
  SET_PRODUCT_COUNTER_STRING: "ProductItems/setProductCounterString",
  UPDATE_MENU_SHIMMER: "ProductItems/updateMenuShimmer",
  UPDATE_HOME_SHIMMER: "ProductItems/updateHomeShimmer",

  //Menu keys
  UPDATE_SELECTED_MENU_ITEM: "Menu/updateSelectedMenuItem",
  UPDATE_MENU_MODAL_FLAG_OPENED_FROM: "Menu/updateMenuModalFlagOpenedFrom",
  UPDATE_NEW_MENU_MODAL_FLAG: "Menu/updateNewMenuModalFlag",
  UPDATE_CLICKED_CATEGORY_ANCHOR_LINK: "Menu/updateClickedCategoryAnchorLink",
  UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS:
    "Menu/updateStopHorizontalScrollAnchorLinks",
  UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK:
    "Menu/updateStopHorizontalScrollAnchorLinksFilterClick",

  //Cart keys
  UPDATE_CART_ITEMS_LISTING_PAGE_ITERATOR:
    "Cart/updateCartItemsListingPageIterator",
  ADD_TO_CART: "Cart/addToCart",
  REMOVE_FROM_CART: "Cart/removeFromCart",
  UPDATE_ITEM_IN_CART: "Cart/updateItemInCart",
  ADD_TO_NEW_CART: "Cart/addToNewCart",
  REMOVE_FROM_NEW_CART: "Cart/removeFromNewCart",
  UPDATE_NEW_ITEMS: "Cart/updateNewItems",
  UPDATE_CART_FROM_NEW_ITEMS: "Cart/updateCartFromNewItems",
  CANCEL_UPDATE_CART_FROM_NEW_ITEMS: "Cart/cancelUpdateCartFromNewItems",
  LOAD_CART_FROM_STORAGE_SERVICE: "Cart/loadCartFromStorageService",
  UPDATE_MAXIMUM_ALLOWED_CHARACTERS: "Cart/updateMaximumAllowedCharacters",
  UPDATE_ADVANCE_ORDER_TIME_SLOT: "Cart/updateAdvanceOrderTimeSlot",
  UPDATE_SHOW_TIP_TOAST_MSG: "Cart/updateShowTipToastMsg",
  UPDATE_VALID_COMBO_LIST_WITH_INVALID_ITEMS:
    "Cart/updateValidComboListWithInvalidItems",
  UPDATE_INVALID_ITEMS_FORMATTED: "Cart/updateInvalidItemsFormatted",
  UPDATE_APPLIED_UPSELL_FILTER: "Cart/updateAppliedUpsellFilter",
  UPDATE_AMOUNT_SAVED_MSG: "Cart/updateAmountSavedMsg",
  UPDATE_CART_ERROR: "Cart/updateCartError",
  UPDATE_LAST_INTERACTED_PRODUCT_WITH_UPSELL_ITEM:
    "Cart/updateLastInteractedProductwithUpsellItem",
  UPDATE_SELECTED_LIST_UPSELL_ITEMS: "Cart/updateSelectedListUpSellItems",
  UPDATE_WALLET_NAME: "Cart/updateWalletName",
  UPDATE_CART_MINI_IMAGES: "Cart/updateCartMiniImages",
  UPDATE_CART_SHIMMER: "Cart/updateCartShimmer",

  //Csat keys
  UPDATE_SELECTED_RATING: "CsatFeedback/updateSelectedRating",
  UPDATE_FOOD_RATING: "CsatFeedback/updateFoodRating",
  UPDATE_DELIVERY_RATING: "CsatFeedback/updateDeliveryRating",
  UPDATE_VALUE_FOR_MONEY_RATING: "CsatFeedback/updateValueForMoneyRating",
  UPDATE_COMMENT: "CsatFeedback/updateComment",
  UPDATE_RAISE_TICKET: "CsatFeedback/updateRaiseTicket",
  UPDATE_NPS_CSAT_MODAL_FLAG: "CsatFeedback/updateNpsCsatModalFlag",

  //Auth keys
  UPDATE_LOGGIN_STATE: "Auth/updateLogginState",
  UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD:
    "Auth/updateShowWelcomeScreenOnPgLoad",
  UPDATE_CURRENT_LOGIN_STATE: "Auth/updateCurrentLoginState",
  UPDATE_LOCAL_STORAGE_USER_DATA: "Auth/updateLocalStorageUserData",
  UPDATE_LOGIN_STATE_STATUS: "Auth/updateLoginStateStatus",
  UPDATE_SHOW_PROFILE_DRAWER_MODAL: "Auth/updateShowProfileDrawerModal",
  UPDATE_LOGIN_PROPS: "Auth/updateLoginProps",
  UPDATE_LOGIN_ERROR: "Auth/updateLoginError",
  UPDATE_IS_HAMBURGER: "Auth/updateIsHamburger",
  UPDATE_AUTO_SELECT_USER_ADDRESS: "Auth/updateAutoSelectUserAddress",

  //Location keys
  UPDATE_SHOW_FETCH_LOCATION_MODAL: "Location/updateShowFetchLocationModal",
  UPDATE_CURRENT_LOCATION: "Location/updateCurrentLocation",
  UPDATE_SHOW_DELIVERY_MAP_SCREEN: "Location/updateShowDeliveryMapScreen",
  UPDATE_SHOW_MANUAL_LOCATION_SCREEN: "Location/updateShowManualLocationScreen",
  UPDATE_LOCATION_FROM_LOCAL_STORAGE: "Location/updateLocationFromLocalStorage",
  RESET_LOCATIONSTATE: "Location/resetLocationState",
  UPDATE_IS_LOCATION_SETTLED: "Location/updateIsLocationSettled",
  UPDATE_STORE_DETAILS: "Location/updateStoreDetails",
  UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL:
    "Location/updateShowLocationAccessBlockedModal",
  UPDATE_SHOW_LOCATION_PERMISSION_MODAL:
    "Location/updateShowLocationPermissionModal",
  UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL:
    "Location/updateShowAlternateLocationPermissionModal",
  UPDATE_ALTERNATE_LOCATION_POPUP_DATA:
    "Location/updateAlternateLocationPopupData",
  CLEAR_AUTOCOMPLETE_INPUT: "Location/clearAutoCompleteInput",
  UPDATE_AUTOCOMPLETE_INVALID_INPUT: "Location/updateAutoCompleteInvalidInput",
  UPDATE_GOOGLE_ADDRESS_COMPONENT: "Location/updateGoogleAddressComponent",
  UPDATE_SHOW_LOCATION_LOADING: "Location/updateShowLocationLoading",
  UPDATE_NO_INTERNET: "Location/updateNoInternet",
  UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION:
    "Location/updateTakeAwayOrDineInStoreOnSelection",
  UPDATE_ADDRESS_TOOLTIP: "Location/updateAddressTooltip",
  UPDATE_IS_LOCATION_PERMISSION_GIVEN:
    "Location/updateIsLocationPermissionGiven",
  UPDATE_SHOW_UNAVAILABLE_HEADER: "Location/updateShowUnavailableHeader",

  // User Keys
  UPDATE_CURRENT_ORDER_TYPE: "User/updateCurrentOrderType",
  UPDATE_SELECTED_ORDER_TYPE: "User/updateSelectedOrderType",
  LOAD_CURRENT_ORDER_TYPE: "User/loadCurrentOrderType",
  TOGGLE_ADD_EDIT_ADDRESS_LOCATION_SCREEN:
    "User/toggleAddEditAddressLocationScreen",
  DELETE_SAVED_ADDRESSESS: "User/deleteSavedAddress",
  UPDATE_SAVED_ADDRESSESS: "User/updateSavedAddresses",
  TRIGGER_EDIT_ADDRESS_MODAL: "User/triggerEditAddressModal",
  EDIT_SAVE_ADDRESS: "User/editSaveAddress",
  ADD_SAVE_ADDRESS: "User/addSaveAddress",
  SHOW_MY_ADDRESS_MODAL: "User/updateShowMyAddressModal",
  UPDATE_SELECTED_USER_ADDRESS: "User/updateSelectedUserAddress",

  //Offer keys
  UPDATE_SELECTED_OFFER_INDEX: "Offers/updateSelectedOfferIndex",
  UPDATE_OFFER_DETAILS_MODAL_FLAG: "Offers/updateOfferDetailsModalFlag",
  UPDATE_PAYMENT_OFFER_DETAILS_MODAL_FLAG:
    "PaymentOffers/updateSelectedPaymentOfferTnc",
  UPDATE_SELECTED_PAYMENT_OFFER_INDEX:
    "PaymentOffers/updateSelectedPaymentOfferIndex",
  UPDATE_OFFER_APPLY_RESPONSE: "Offers/updateOfferApplyResponse",
  UPDATE_TOP_COUPON: "Offers/updateTopCoupon",
  UPDATE_MANUAL_OFFER: "Offers/updateManualOffer",
  UPDATE_OFFER_FAILED_MSG: "Offers/updateOfferFailedMsg",
  UPDATE_IS_CART_SELECTED: "Offers/updateIsCartSelected",
  UPDATE_APPLIED_COUPON_PROMO: "Offers/updateAppliedOfferPromo",
  UPDATE_VIEW_ALL_OFFERS: "Offers/updateViewAllOffers",
  UPDATE_OFFER_APPLY_MODAL: "Offers/updateOfferAppliedModal",
  UPDATE_SELECTED_OFFER: "Offers/updateSelectedOffer",
  UPDATE_ORDER_SUMMARY: "OrderTracking/updateOrderSummary",
  UPDATE_ORDER_ID: "OrderTracking/updateOrderId",
  ADD_DELIVERED_ORDER_IDS: "OrderTracking/addDeliveredOrderId",
  ADD_NPS_FIRED_ORDER_IDS: "OrderTracking/addNpsFiredOrderId",
  UPDATE_INIT_OFFER_LISTING_WRAPPER: "Offers/updateInitOfferListingWrapper",
  UPDATE_OFFER_DETAILS_FROM_BOTTOM_BAR:
    "Offers/updateOfferDetailsFromBottomBar",
  UPDATE_SELECTED_OFFER_THEME: "Offers/updateSelectedOfferTheme",
  UPDATE_DESKTOP_TNC_SHIMMER: "Offers/updateDesktopTncShimmer",

  //Profile keys
  UPDATE_PROFILE_DATA: "Profile/updateProfileData",
  UPDATE_SHOW_PROFILE_MODAL: "Profile/updateShowProfileModal",
  UPDATE_SHOW_EDIT_PROFILE_MODAL: "Profile/updateShowEditProfileModal",
  UPDATE_SHOW_THANK_YOU_MODAL: "ThankYou/updateShowThankYouModal",
  UPDATE_FOCUSED_STORE: "Location/updateFocusedStore",
  UPDATE_IS_TAKEWAY_SELECTED: "Location/updateIsTakeAwaySelected",
  UPDATE_OTHER_TIP: "Cart/updateOtherTip",
  UPDATE_SELECTED_TIP: "Cart/updateSelectedTip",
  UPDATE_CART_ITEMS: "Cart/updateCartItems",
  UPDATE_TIP: "Cart/updateTip",
  UPDATE_TIP_AUTOMATICALLY_SELECT: "Cart/updateTipAutomaticallySelect",
  UPDATE_SHOW_ITEM_TOAST_MSG: "Cart/updateShowItemToastMsg",
  UPDATE_ITEM_TOAST_MSG: "Cart/updateItemToastMsg",
  UPDATE_SHOW_SCHEDULE_DELIVERY: "Cart/updateShowScheduleDelivery",

  UPDATE_DELIVERY_INSTRUCTIONS: "Cart/updateDeliveryInstructions",
  UPDATE_DELIVERY_INSTRUCTIONS_CHARS: "Cart/updateDeliveryInstructionsChars",
  UPDATE_DIRECTIONS_TO_REACH: "Cart/updateDirectionsToReach",
  SHOW_ADVANCE_ORDER_MODAL: "Cart/showAdvanceOrderModal",
  UPDATE_LAST_INTERACTED_PRODUCT_CARD: "Cart/updateLastInteractedProductCard",

  UPDATE_VWO_EXPERIMENTS: "Config/updateVwoExperiments",

  UPDATE_NOTIFICATION_STATUS_DATA: "Notification/updateNotificationStatusData",
  UPDATE_SHOW_NOTIFICATION_STATUS_DATA:
    "Notification/updateShowNotificationStatusData",
  UPDATE_NOTIFICATION_VISIBILITY_STATUS_DATA:
    "Notification/updateNotificationVisibilityStatusData",
  UPDATE_NOTIFICATION_POSITION: "Notification/updateNotificationPosition",
  REMOVE_NOTIFICATOIN_STATUS_DATA: "Notification/removeNotificationStatusData",
  UPDATE_LOADING_STATE: "Loader/updateLoadingState",
  UPDATE_MAP_SCREEN_LOADING: "Loader/updateMapScreenLoading",
  // Guest user keys
  SAVE_ADDRESS_DETAILS: "GuestUser/saveAddressDetail",
  UPDATE_ADD_CONTACT_DETAILS_MODAL: "GuestUser/updateAddContactDetailsModal",
};

export const keyMapsGetter = {
  GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR:
    "ProductItems/getCategoryNameAndCountForBottomBar",
  GET_APPLIED_FILTERS: "ProductItems/getAppliedFilters",
  GET_UPSELL_PRODUCTS: "ProductItems/getUpsellProducts",
  GET_CATEGORISED_UPSELL_PRODUCTS: "ProductItems/getCategorisedUpsellProducts",
  GET_APPLIED_UPSELL_FILTER: "Cart/getAppliedUpsellFilter",
  GET_APPLIED_SORTS: "ProductItems/getAppliedSorts",
  GET_SUB_CATEGORY_MODAL_DATA: "ProductItems/getSubCategoryModalData",
  CART_TOTAL: "Cart/cartTotal",
  CART_SAVINGS: "Cart/cartSavings",
  GET_LAST_ADDED_ITEM_FROM_CART: "Cart/lastAddedItemFromCart",
  CART_QUANTITY: "Cart/cartQuantity",
  VALID_CART_QUANTITY: "Cart/validCartQuantity",
  CART_GET_INDIVIDUAL_QUANTITY: "Cart/getIndividualQuantity",
  GET_CART_ITEMS: "Cart/getCartItems",
  GET_SEPARATE_VARIANTS: "Cart/getSeparateVariants",
  GET_CART_DETAILS_FOR_ANALYTICS: "Cart/getCartDetailsForAnalytics",
  GET_CART_CALCULATIONS_FOR_ANALYTICS: "Cart/getCartCalculationsForAnalytics",
  GET_CART_TAX_AND_CHARGES_CALCULATIONS_FOR_ANALYTICS:
    "Cart/getCartTaxAndChargesCalculationsForAnalytics",
  GET_CART_DISCOUNT_CALCULATIONS_FOR_ANALYTICS:
    "Cart/getCartDiscountCalculationsForAnalytics",
  GET_CART_COUPON_DETAILS: "Cart/getCartCouponDetails",
  GET_PRODUCTS: "ProductItems/getProducts",
  PRODUCT_SEARCH_RESULTS: "ProductItems/productSearchResults",
  //GET_PRODUCT_ITEM_FOR_BOTTOMBAR: "ProductItems/getProductItemForBottomBar",
  GET_PROFILE_DATA: "Profile/getProfileData",
  GET_SHOW_PROFILE_MODAL: "Profile/getShowProfileModal",
  GET_SHOW_EDIT_PROFILE_MODAL: "Profile/getShowEditProfileModal",
  GET_SHOW_THANK_YOU_MODAL: "ThankYou/getShowThankYouModal",
  GET_GLOBAL_UPSELL_ITEMS: "Cart/getGlobalUpsellItems",
  GET_VWO_EXPERIMENTS: "Config/getVwoExperiments",
  GET_REARRANGED_SAVED_ADDRESS: "User/getRearrangedSavedAddress",
  GET_PRODUCT_ITEMS: "ProductItems/getProductItems",
  GET_FINGER_PRINT_DATA: "FingerPrint/getFpInfoData",
  GET_VALID_ACTIVE_ORDERS: "OrderTracking/getValidActiveOrders",
  GET_CURRENT_TRACKED_ORDER: "OrderTracking/getCurrentTrackedOrder",
};
